import React from "react";
import { Card, Image } from "semantic-ui-react";
import { Svg } from "../../../../assets";
import "./styles.scss";

export interface AssetPreview {
  assetId: string;
  thumbnail?: string;
  href?: string;
}

interface OwnProps {
  asset: AssetPreview;
  onClick?: (asset: AssetPreview, e: React.MouseEvent) => void;
}

type Props = OwnProps;

export const AssetPreviewCard: React.FC<Props> = ({ asset, onClick }) => {
  return (
    <Card
      className={"assetPreviewCard"}
      link
      onClick={e => {
        onClick && onClick(asset, e);
      }}
      href={asset.href}
    >
      <Image
        as="a"
        src={asset.thumbnail || Svg.PromptPlaceholder}
        className={`previewImage ${asset.thumbnail ? "" : "placeholder"}`}
      />
    </Card>
  );
};
